// api/kontenrahmen.ts
import { Buchung } from "./buchung.js";
var SKR04 = {
  Bestandskonten: {
    Aktivkonten: {
      Sachanlagen: "0400",
      Forderungen: "1200",
      Bank: "1800"
    },
    Passivkonten: {
      Eigenkapital: "2000",
      Verbindlichkeiten: "2500"
    }
  },
  Erfolgskonten: {
    Aufwandskonten: {
      Miete: "4100",
      Geh\u00E4lter: "4200",
      Materialkosten: "4300"
    },
    Erloeskonten: {
      Umsatzerl\u00F6se: "5000",
      Zinsertr\u00E4ge: "5200",
      Provisionserl\u00F6se: "5300"
    }
  }
};
function useKontenRahmen(kontenRahmen) {
  const flattened = /* @__PURE__ */ new Map();
  const makeFlattened = (current) => {
    for (const [key, value] of Object.entries(current))
      if (typeof value === "string")
        flattened.set(key, value);
      else
        makeFlattened(value);
  };
  makeFlattened(SKR04);
  function getKontoNummer(name) {
    return flattened.get(name);
  }
  function getKontoName(nummer) {
    return [...flattened.entries()].find((entry) => entry[1] === nummer)?.[1];
  }
  const buchungsClass = Buchung;
  buchungsClass.constructor.kontenRahmen = kontenRahmen;
  return { buchungsClass, getKontoNummer, getKontoName, kontenRahmen };
}
export {
  SKR04,
  useKontenRahmen
};
